"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOMStateInjector = void 0;
const react_1 = require("react");
const jotai_1 = require("jotai");
const atom_1 = require("../../../atom");
const DOMStateInjector = () => {
    const setDomReadyState = (0, jotai_1.useSetAtom)(atom_1.$DOMReadyState);
    (0, react_1.useEffect)(() => {
        if (document.readyState !== 'loading') {
            setDomReadyState(document.readyState);
        }
        if (document.readyState !== 'complete') {
            const handleReadyStateChanged = () => {
                const state = document.readyState;
                setDomReadyState(state);
                if (state === 'complete') {
                    document.removeEventListener('readystatechange', handleReadyStateChanged);
                }
            };
            document.addEventListener('readystatechange', handleReadyStateChanged);
        }
    }, []);
    return null;
};
exports.DOMStateInjector = DOMStateInjector;
